import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=0425edfe"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0425edfe')) {
      api.createRecord('0425edfe', component.options)
    } else {
      api.reload('0425edfe', component.options)
    }
    module.hot.accept("./DashboardView.vue?vue&type=template&id=0425edfe", function () {
      api.rerender('0425edfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/DashboardView.vue"
export default component.exports